import { Component, OnInit } from '@angular/core';
import { BaseViewComponent } from '../base-view/base-view.component';
import { DialogControllerService } from '../../services/dialog-controller/dialog-controller.service';
import { DialogIdentifier } from '../../services/dialog-identifier';
import { UploadService } from '../../services/upload/upload.service';

@Component({
  selector: 'baf-upload-view',
  templateUrl: './upload-view.component.html',
  styleUrls: ['./upload-view.component.css']
})
export class UploadViewComponent extends BaseViewComponent {
  constructor(dialogController: DialogControllerService, private upload: UploadService) {
    super(DialogIdentifier.UploadView, dialogController);
  }

  get progress(): number {
    return this.upload.progress;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/upload-view/upload-view.component.ts